// Endereços e dados de contato usados pela Capa e pela LP da Vitrine.

export const SITE_URL = 'https://www.yuha.com.br';
/** Identificador do WebSite no JSON-LD (as páginas apontam para ele em `isPartOf`). */
export const WEBSITE_ID = `${SITE_URL}/#website`;

export const ROUTES = {
  home: '/',
  vitrine: '/link-bio/',
  privacy: '/privacidade/',
  terms: '/termos-de-uso/',
  // Servidos por outros projetos no mesmo domínio
  signup: '/signup/',
  signin: '/signin/',
  partners: '/parceiros/',
  blog: '/blog/',
} as const;

export const CONTACT = {
  email: 'comercial@yuha.com.br',
  whatsappLabel: '+55 31 98489-0419',
  whatsappUrl: 'https://wa.me/message/HWNDQSYZJ7HIC1',
  hours: 'Disponível de Segunda a Sexta, 9:00 – 18:00',
  privacyEmail: 'privacidade@yuha.com.br',
  phone: '(31) 2534-2101',
  cnpj: '61.178.037/0001-07',
  address: 'Rua dos Timbiras, nº 2352, 6º andar - Belo Horizonte - MG',
};

export const SOCIAL = {
  instagram: 'https://www.instagram.com/yuhadatalab/',
  linkedin: 'https://www.linkedin.com/company/yuhadatalab/',
};

/** Endereço de exemplo de uma vitrine publicada (o extractor usa o prefixo www.yuha.com.br/vitrine/). */
export const SHOWCASE_URL_EXAMPLE = 'yuha.com.br/vitrine/seunome';

export const OG_IMAGE = `${SITE_URL}/global/logo.webp`;
